import React from 'react';
import { Dialog, DialogTitle, Typography, Divider } from '@material-ui/core';
import PropTypes from 'prop-types';

function CustomModal({ children, open = false, handleClose, title = 'Modal' }) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography color="textPrimary" variant="h2">
          {title}
        </Typography>
      </DialogTitle>
      <Divider />
      {children}
    </Dialog>
  );
}

CustomModal.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string
};

export default CustomModal;
